import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch, { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { PriceHistoryResponse } from "./type.ts";

export const usePriceHistory = () => {
  const { id } = useParams();
  const { token } = useAuth();

  const fetch = useFetch();

  const { data, isLoading, isError, error, refetch } = useQuery<PriceHistoryResponse | null, Error, PriceHistoryResponse>({
    queryKey: ["price-history", id],
    enabled: !!id && id !== "new",
    queryFn: () =>
      fetch<PriceHistoryResponse>(`${Urls.PriceHistory}`, {
        method: "GET",
        slug: {
          bookingId: id,
        },
      }, true, token),
    gcTime: CacheTime,
    staleTime: CacheTime,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting price history");
    }
  }, [error?.message, isError]);

  return {
    data: data || [],
    isFetching: isLoading,
    refetch
  };
};
